import React, { useState } from "react";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { useFormik } from "formik";
import * as Yup from "yup";
import AuthService from "../../services/auth/auth";
import { useDispatch, useSelector } from "react-redux";
import { replace, useNavigate } from "react-router";
import { toastError, toastSuccess } from "../../components/ToastNotification";
import { setUser } from "../../store/slices/superAdmin";
import Logo from "../../assets/images/Frame 2.svg";
import Loader from "../../assets/images/loader.gif";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async ({ email, password }) => {
    setIsLoading(true);
    try {
      const response = await AuthService?.login(email, password);
      if (response) {
        toastSuccess("login successfully!");
        localStorage.setItem("guideproaAI_admin", response?.data?.token);
        dispatch(setUser(response?.data?.data));

        console.log("🚀  response.data.data?.admintype:", response.data.data?.admintype);
        if (response.data.data?.admintype === "Admin" || response.data.data?.admintype === "OrganizationAdmin" || response.data.data?.admintype === "IndividualAdmin") {
          console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa")
          navigate("/user", { replace: true });
        }
        if (response.data.data?.admintype === "SuperAdmin") {
          console.log("bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb")
          navigate("/admin", { replace: true });
        }
      }
    } catch (error) {
      toastError(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Formik configuration
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: handleSubmit,
  });

  return (
    <div className="flex items-center justify-center h-screen w-full max-tab:px-5 bg-body">
      <div className="max-w-xl w-full overflow-hidden rounded-md border-input borders">
        <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8 w-full h-fit shadow-lg bg-white/30 before-shadow relative">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm grid justify-center text-center">
            <div className="w-[100px] h-[100px] mx-auto flex justify-center items-center rounded-full overflow-hidden">
              <img src={Logo} alt="" />
            </div>
            <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-primary">
              Log in to your account
            </h2>
          </div>

          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form className="space-y-6" onSubmit={formik.handleSubmit}>
              <div className="grid w-full items-center gap-1.5">
                <Label htmlFor="email">Email</Label>
                <Input
                  type="email"
                  id="email"
                  placeholder="Enter Your Email"
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-red-500">{formik.errors.email}</div>
                ) : null}
              </div>

              <div className="grid w-full items-center gap-1.5">
                <Label htmlFor="password">Password</Label>
                <div className="relative">
                  <Input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder="Enter Your Password"
                    name="password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                  />
                  <div
                    className="absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? (
                      <FaEyeSlash className="text-gray-400" />
                    ) : (
                      <FaEye className="text-gray-400" />
                    )}
                  </div>
                </div>

                {formik.touched.password && formik.errors.password ? (
                  <div className="text-red-500">{formik.errors.password}</div>
                ) : null}
              </div>

              <div className="mt-4">
                <Button
                  type="submit"
                  className="w-full flex gap-2 bg-primary hover:bg-btnHover text-white text-base"
                >
                  {isLoading ? (
                    <img src={Loader} alt="Loader" className="w-7" />
                  ) : (
                    "Login"
                  )}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
